













































































import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import RuleScriptParameter from '@/domain/scripts/entity/rule-script-parameter.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import Parameters from './parameter-type.json';
import ParameterDefinition from './parameter-definition-component.vue';

@Component({
  components: {
    LabelSlot,
    VbTooltipSlot,
    ParameterDefinition,
    ModalWarning,
  },
})
export default class ScriptContent extends Vue {
  @Prop({
    required: true,
  })
  ruleScript!: RuleScript;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
    default: false,
  })
  previewModeValue!: boolean;

  parameters = Parameters;

  ref: any = this.$refs;

  ruleToEdit: RuleScript = RuleScript.of({});

  rules: Rules = new Rules();

  valid: boolean = false;

  showRemoveParameterWarning: boolean = false;

  parameterToRemove: RuleScriptParameter | null = null;

  removeParameterWarningMessage: string = 'Ao remover este parâmetro, ele deixará de estar '
    + 'disponível para uso na regra de cálculo. Se ele já estiver sendo utilizado no script, '
    + 'a regra poderá parar de funcionar corretamente. Deseja realmente remover?';

  updateRuleParameters() {
    this.$emit('parameters', this.ruleToEdit);
    this.$emit('valid', this.valid);
  }

  addNewParameter() {
    this.ruleToEdit.addParameter();
  }

  askRemoveParameter(parameter: RuleScriptParameter) {
    this.parameterToRemove = parameter;
    this.showRemoveParameterWarning = true;
  }

  confirmRemoveParameter() {
    if (this.parameterToRemove) {
      this.ruleToEdit.removeParameter(this.parameterToRemove);
    }
    this.cancelRemoveParameter();
  }

  cancelRemoveParameter() {
    this.showRemoveParameterWarning = false;
    this.parameterToRemove = null;
  }

  updateIndexParameterUp(parameter: RuleScriptParameter) {
    this.ruleToEdit.updateIndexUp(parameter);
  }

  updateIndexParameterDown(parameter: RuleScriptParameter) {
    this.ruleToEdit.updateIndexDown(parameter);
  }

  insertParameterToScript(parameter: RuleScriptParameter) {
    this.$emit('insertParameterToScript', parameter);
  }

  @Watch('ruleScript')
  onRuleScriptChange() {
    this.syncRuleToEdit();
  }

  created() {
    this.syncRuleToEdit();
  }

  syncRuleToEdit() {
    if (this.ruleScript) {
      if (this.ruleScript.hasParameter()) {
        const parametersSorted = this.ruleScript.parameters
          .sort((elA: RuleScriptParameter, elB: RuleScriptParameter) => elA.index - elB.index)
        this.ruleScript.parameters = parametersSorted
      }
      this.ruleToEdit = this.ruleScript;
    }
  }
}
